<template>
  <div
    id="modal-message-html"
    class="modal modal--second modal--message modal-journal"
  >
    <div class="modal__bg"></div>
    <div class="modal__content modal__content__html">
      <!-- <div class="modal__content modal__content--message">   -->
      <div class="modal__content_header">
        <button
          class="modal__close"
          type="button"
          @click="$emit('closeWindow')"
        >
          <img
            src="@/assets/img/icons/close.svg"
            alt=""
            width="24"
            height="24"
          />
        </button>
        <span class="modal__title"> Пакет документов </span>
      </div>
      <div class="modal__content_main">
        <div class="modal__content_footer">
          <div class="modal__content_nav">
            <div class="modal__content_nav_list" v-if="this.fileCount > 1">
              <PagePagination
                :countPages="this.fileCount"
                @onChangePage="
                  (value) => {
                    this.activeMessage = value;
                  }
                "
              />
            </div>
            <div class="modal-btn-cover">
              <button
                class="modal-btn-html"
              >
                <a
                  width="100%"
                  :href="`/outside/show_message?path=${this.filePathArr[2]}\\${this.filePathArr[1]}\\${this.activeMessage}_${this.fileName}`"
                  download="document.html"
                >
                  Скачать
                </a>
              </button>
              <button
                class="modal-btn-html"
                href="javascript:void(0);"
                @click="this.PrintIFrame"
              >
                Печать
              </button>
              <button
                class="modal-btn-html"
                type="button"
                @click="$emit('closeWindow')"
              >
                Закрыть
              </button>
            </div>
          </div>
        </div>
        <!-- <div
          class = "modal__content_nav"
        >
          <div 
            class = "modal__content_nav_list"
            v-if="this.fileCount > 1"
          >
            <PagePagination
              :countPages = "this.fileCount"
              @onChangePage = "(value) => {
                this.activeMessage = value
              }" 
            />
          </div>

          <ul class = "modal__content_nav_list">
            <li
              class = "modal__content_nav_btn"
            >
             
              <a 
                class = "modal-btn"
                :href="`/outside/show_message?path=${this.filePathArr[2]}\\${this.filePathArr[1]}\\${this.activeMessage}_${this.fileName}`"
                download="document.html"
              >
                Скачать
              </a>
            </li>
            <li
              class = "modal__content_nav_btn"
            >
              <a 
                class = "modal-btn"
                href="javascript:void(0);"
                @click="this.PrintIFrame"
              >
                Печать
              </a>
            </li>
          </ul>
        </div> -->
        <iframe
          id="show-message-frame"
          class="frame_dt_message to-print modal__content_data"
          @load="addStyle"
          :src="`/outside/show_message?path=${this.filePathArr[2]}\\${this.filePathArr[1]}\\${this.activeMessage}_${this.fileName}`"
          frameBorder="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { addStyleToIFrame, iFrameHeightbyContent } from "@/common/utils.js";
import PagePagination from "@/components/PagePagination";

// // Обработчик события beforeprint
// window.onbeforeprint = function() {
//   let iframe = document.getElementById('show-message-frame');
//   if (iframe) {
//     iframe.contentWindow.print();
//   }
// };

export default {
  name: "MessageHTMLComponent",
  components: {
    PagePagination,
  },
  data: () => ({
    activeMessage: 1,
    fileName: "",
    fileCount: 0,
    filePathArr: [],
    smallWindow: false,
  }),
  props: {
    filePath: {
      type: String,
      required: true,
    },
  },
  emits: ["closeWindow"],
  methods: {
    addStyle() {
      addStyleToIFrame(
        "show-message-frame",
        "/css_for_incoming/iframe_message.css"
      );
      // if (this.smallWindow)
      iFrameHeightbyContent("show-message-frame");
    },
    getFrameData() {
      // Получаем элемент iframe
      let iframe = document.getElementById("show-message-frame");

      // Проверяем, что iframe существует
      if (iframe) {
        return iframe.contentWindow.document.body.innerHTML;
      }
      return "";
    },
    saveFrameHtmlBodyToFile() {
      let htmlContent = this.getFrameData();
      if (htmlContent.length === 0) return;
      let link = document.createElement("a");
      link.href = "data:text/html," + encodeURIComponent(htmlContent);
      link.download = "document.html";

      // Добавляем ссылку в DOM и сразу же удаляем
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // saveFile(url, filename) {
    //   const a = document.createElement("a");
    //   a.href = url;
    //   a.download = filename || "file-name";
    //   document.body.appendChild(a);
    //   a.click();
    //   document.body.removeChild(a);
    // },
    PrintIFrame(event) {
      if (event) {
        event.preventDefault();
      }

      let iframe = document.getElementById("show-message-frame");
      if (iframe) {
        const iframeWindow = iframe.contentWindow || iframe;
        iframe.focus();
        iframeWindow.print();
      }
    },
    onResize() {
      this.smallWindow = window.innerWidth <= 600;
    },
  },
  mounted() {
    this.filePathArr = this.filePath.split("\\").reverse();
    if (!this.filePathArr) return;
    let fileNameArr = this.filePathArr[0].split("_");
    this.fileCount = +fileNameArr[0];
    //удаляем первый элемент из названия, для дальнейшего корректного формирования номера файла
    fileNameArr.shift();
    this.fileName = fileNameArr.join("_");

    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
